import { GlobalConfig } from '../models/GlobalConfig';

let _config: GlobalConfig | null = null;

export const SetConfig = (config: Partial<GlobalConfig>): void => {
    _config = { ...(_config || {}), ...config } as GlobalConfig;
};

export const GetConfig = (): GlobalConfig | null => _config;
